module.exports = __webpack_public_path__ + "static/img/Tariq-Sims.3e76150.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tariq-Sims.jpg
// module id = nw+g
// module chunks = 0